module.exports = __webpack_public_path__ + "img/Deco_ceremonie.420ceb0.png";